export enum MapPeriodoDeConsumoRotulo {
  aoMesmoTempo = "ao mesmo tempo",
  naMesmaAtividade = "por atividade",
  noMesmoDia = "por dia",
  naMesmaSemana = "por semana",
  noMesmoMes = "por mês",
}
